import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { signOut } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";

import ProfileModal from "./Items/ProfileModal";

// Style
import logo from "../../assets/visual/icon-white.png";
import { Menu } from "semantic-ui-react";

const Navbar = () => {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const dispatch = useDispatch();

  const [state, setState] = useState(true);

  useEffect(() => {
    const path = window.location.pathname;

    if (path === "/member") {
      setState(false);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(signOut());
  };

  if (uid) {
    return (
      <Menu size="massive" style={{ background: "royalblue" }} inverted>
        <Link to="/">
          <Menu.Item style={{ height: "100%" }}>
            <img
              alt="oi-logo"
              // src="https://firebasestorage.googleapis.com/v0/b/omnes-immigration.appspot.com/o/assets%2Fimages%2Ficon-set%2Ficon-america-white.png?alt=media&token=a665b501-4f49-4879-b135-0854a9a3d76f"
              src={logo}
            />
          </Menu.Item>
        </Link>

        <Menu.Menu position="right">
          {/* <ProfileModal /> */}
          <Link to="/">
            <Menu.Item
              name="signout"
              onClick={handleSubmit}
              style={{ color: "white", height: "100%" }}
            >
              End Session
            </Menu.Item>
          </Link>
        </Menu.Menu>
      </Menu>
    );
  }
  return (
    <>
      <Menu size="massive" style={{ background: "royalblue" }} inverted>
        <Link to={state ? "/signin" : "/signup"}>
          <Menu.Item style={{ height: "100%" }}>
            <img
              alt="oi-logo"
              // src="https://firebasestorage.googleapis.com/v0/b/omnes-immigration.appspot.com/o/assets%2Fimages%2Ficon-set%2Ficon-america-white.png?alt=media&token=a665b501-4f49-4879-b135-0854a9a3d76f"
              src={logo}
            />
          </Menu.Item>
        </Link>
        <Menu.Menu position="right">
          <Link to={state ? "/signup" : "/signin"}>
            <Menu.Item
              onClick={() => setState(!state)}
              name="signup"
              style={{ color: "white", height: "100%" }}
              content={state ? "Sign Up" : "Sign In"}
            />
          </Link>
        </Menu.Menu>
      </Menu>
    </>
  );
};

export default Navbar;
